import SettingsPage from './list';

export default SettingsPage;
